export const set_map_state = (state) => {
    return {
        type: 'SET_MAP_STATE',
        payload: state
    }
}